<div class="main-container">
  <div class="page-info">
    <h3 class="title">
      <!-- Business Name and Address -->
      {{ "advanced-pages.business-tax.tax-id" | i18next }}
      <span class="required-mark">*</span>
    </h3>
    <!-- <p class="note tw-pt-4">
      {{ "advanced-pages.business-info.businessname-description" | i18next }}
      <!-- Provide your registered business name and address as shown in business
      documents, bills, etc.
    </p> -->
  </div>

  <div class="tw-overflow-auto tw-pb-[100px]">
    <!-- <app-settings-card-payments-section
    [sectionTitle]="'advanced-pages.business-tax.tax-id' | i18next"
  > -->
    <app-reactive-text-input
      [placeholder]="'advanced-pages.business-tax.tax-id' | i18next"
      type="text"
      [required]="true"
      [control]="businessForm"
      [minNum]="13"
      [maxNum]="15"
      [isTaxId]="true"
      reference="businessTax"
    />
    <!-- <div
      class="tw-fixed tw-bottom-0 tw-left-0 tw-flex tw-px-5 tw-py-4 tw-gap-4 tw-w-full tw-bg-white"
    >
      <button class="btn-secondary tw-w-1/2" (click)="goBack()">
        {{ "advanced-pages.business-tax.back" | i18next }}
      </button>
      <button
        class="tw-w-1/2 btn-primary"
        [disabled]="!isValid"
        [class]="{disabled:!isValid}"
        (click)="goNext()"
      >
        {{ "advanced-pages.business-tax.next" | i18next }}
      </button>
    </div> -->
    <!-- </app-settings-card-payments-section> -->
  </div>
</div>
<app-cta-buttons
  currentPage="business-info"
  [backButton]="false"
  [pageNames]="advancedPages"
  [nextCallback]="handleNextClick"
  tier="advanced"
  [disabled]="!businessForm.valid || !isValid"
  (nextEvent)="handleNextClick()"
></app-cta-buttons>
